import { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axios/axiosInstance";
import { useAuth } from "../AuthContext";
import { useCart } from "../CreateContext";
import { GlobalContext } from "../GlobalContext";
import { useShowCartNotification } from "../../utils/cartNotification";
import { showCartToast } from "../../utils/cartToastManager";
import { isValidArray } from "../../Layout/Common/common";
import { useGlobalFunction } from "../GlobalFunctionContext";
import { showErrorSnackbar } from "../../utils/snackbarNotifications";
import { useNoteAlert } from "../pleaseNote";

const useAddToCart = () => {
  const { dispatch } = useCart();
  const { userId, priceCode } = useAuth();
  const { setCartItem, setClarificationItem, OrderId, CartItem, setOrderId } = useContext(GlobalContext);
  const { showNoteAlert } = useNoteAlert();
  // Always keep a ref in sync with the latest OrderId to avoid stale closures
  const orderIdRef = useRef(OrderId);
  useEffect(() => {
    orderIdRef.current = OrderId;
  }, [OrderId]);
  const { updateClientItem } = useGlobalFunction();
  const navigate = useNavigate();
  const showCartNotification = useShowCartNotification();

  const handleAddtoCart = async (pid, qty, type) => {
    try {
      const params = {
        userid: String(userId),
        priceCode: String(priceCode),
        orderId: String(orderIdRef.current ?? ""),
        productId: String(pid),
        qty: parseInt(qty),
        key: type,
      };

      const response = await axiosInstance.post("AddtoCart/AddtoCart", params);

      if (response.data !== -1) {
        const cartItem = response.data.cartItem;
        const productData = cartItem.find((item) => item.prod_id === parseInt(pid));
        dispatch({ type: "SET_CART_ITEMS", payload: cartItem });

        showCartToast(productData, type);
        localStorage.setItem("CART_ITEM", JSON.stringify(cartItem));
        setCartItem(response.data);
      } else {
        alert("Something went wrong!");
      }

      const result = await axiosInstance.post("MyCart/GetOrderClarification", {
        userId: String(userId),
        orderId: "0",
      });

      if (result.data) {
        let res = result.data;
        if (res.statusCode != -1 && isValidArray(res.data)) {
          setClarificationItem(res.data);
        }
      }
    } catch (e) {
      showErrorSnackbar("Unable to add item to cart. Please try again.");
    }
  };
  const handleAddtoCartLite = async (pid, qty, type, desc, img, code) => {
    const params = {
      userid: String(userId),
      priceCode: String(priceCode),
      orderId: String(orderIdRef.current ?? ""),
      productId: String(pid),
      qty: parseInt(qty),
      key: type,
    };
    try {
      const response = await axiosInstance.post("AddtoCart/AddtoCart", params);
      if (response.data && response.data !== null) {
        // const cartItem = response.data.cartItem;
        // const productData = cartItem.find((item) => item.prod_id === parseInt(pid));
        // dispatch({ type: "SET_CART_ITEMS", payload: cartItem });

        // showCartToast(productData, type);
        // localStorage.setItem("CART_ITEM", JSON.stringify(cartItem));
        // setCartItem(response.data);
        const cartItem = response.data;
        let productData = {
          prod_id: pid,
          prodImage: img,
          description: desc,
          productCode: code,
          qty: cartItem.qty,
          price: cartItem.price_ext_applied,
        };
        // if (type == "ADD") updateClientItem(1);
        showCartToast(productData, type);
        refreshCartItem(type);
        return true;
      } else {
        showErrorSnackbar("Unable to add item to cart. Please try again.");
        return false;
      }
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        showNoteAlert(e.response.data.message);
      } else {
        showErrorSnackbar("Unable to add item to cart. Please try again.");
      }
      return false;
    }
  };

  const handleUpdateCartItem = async (oid, pid, qty, type, desc, img, code) => {
    const params = {
      userid: String(userId),
      priceCode: String(priceCode),
      orderId: String(oid),
      productId: String(pid),
      qty: parseInt(qty),
      key: type,
    };
    try {
      const response = await axiosInstance.post("AddtoCart/AddtoCart", params);
      if (response.data && response.data !== null) {
        const cartItem = response.data;
        let productData = {
          order_id: oid ?? 0,
          prod_id: pid,
          prodImage: img,
          description: desc,
          productCode: code,
          qty: cartItem.qty,
          price: cartItem.price_ext_applied,
        };
        showCartToast(productData, type);
        return true;
      } else {
        showErrorSnackbar("Unable to add item to cart. Please try again.");
        return false;
      }
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        showNoteAlert(e.response.data.message);
      } else {
        showErrorSnackbar("Unable to add item to cart. Please try again.");
      }
      return false;
    }
  };
  const handleAddtoCartSimple = async (pid, qty, type) => {
    const params = {
      userid: String(userId),
      priceCode: String(priceCode),
      orderId: String(orderIdRef.current ?? ""),
      productId: String(pid),
      qty: parseInt(qty),
      key: type,
    };
    try {
      const response = await axiosInstance.post("AddtoCart/AddtoCart", params);
      if (response.data && response.data !== null) {
        const cartItem = response.data;

        refreshCartItem(type);
        return true;
      } else {
        showErrorSnackbar("Unable to add item to cart. Please try again.");
        return false;
      }
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        showNoteAlert(e.response.data.message);
      } else {
        showErrorSnackbar("Unable to add item to cart. Please try again.");
      }
      return false;
    }
  };
  const refreshCartItem = async (type) => {
    try {
      // Use orderIdRef.current to always get the latest OrderId, avoiding stale closure
      const response = await axiosInstance.post("MyCart/GetMyCartItem", {
        UserID: String(userId),
        OrderID: String(orderIdRef.current ?? "0"),
      });
      if (response.data) {
        dispatch({ type: "SET_CART_ITEMS", payload: response.data.cartItem });
        // Spread to always create a new object reference so React always triggers update
        setCartItem({ ...response.data });
        // Update the ref immediately so subsequent calls use the latest id
        orderIdRef.current = response.data.orderid;
        setOrderId(response.data.orderid);
        localStorage.setItem("CART_ITEM", JSON.stringify(response.data));
      }
    } catch (e) {}
  };

  return { handleAddtoCart, handleAddtoCartLite, handleAddtoCartSimple, handleUpdateCartItem };
};

export default useAddToCart;
